import { getAllComponents } from "./CreateRulesPerPage";

const recreateCustomFunctions = (editor) => {
    const allComps = getAllComponents(editor.DomComponents.getWrapper());
    const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
    const projectsData = JSON.parse(localStorage.getItem('data'));
    const customFunctions = []
    allComps.forEach( (comp) => {
        if(comp.attributes.script !== ''){
            customFunctions.push({id: comp.attributes.attributes.id, customFunction: comp.attributes.script})
        }
    })
    if(projectsData[selectedProject].pages[selectedPage].javascript.customFunctions!== undefined && projectsData[selectedProject].pages[selectedPage].javascript.customFunctions.length !== customFunctions.length){
        projectsData[selectedProject].pages[selectedPage].javascript.changeJavascript = true; 
    }
    projectsData[selectedProject].pages[selectedPage].javascript.customFunctions = customFunctions;

    localStorage.setItem('data', JSON.stringify(projectsData));
}

const handleCustomFunctions = (editor) => {
    
    editor.on('undo', () => {
        recreateCustomFunctions(editor);
    });

    editor.on('redo', () => {
        recreateCustomFunctions(editor);
    });
    editor.on('run:tlb-delete', () => {
        recreateCustomFunctions(editor);
    })
}

export default handleCustomFunctions;
